// extracted by mini-css-extract-plugin
export default {"navigationLinks":"NavigationWithPopups_navigationLinks__XPh4t","navLink":"NavigationWithPopups_navLink__itPHr"};